export default {"src":"/_next/static/image/public/images/no_profile_available.5c4a62e4c5ab190a9d9ce566885e19db.svg","height":184,"width":141};